import { Routes } from '@angular/router'
import { NotFoundComponent } from '@app/pages/not-found/not-found.component'
import { HomePage } from '@app/pages/home/home.page'

export const appRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: HomePage,
    },
    {
        path: 'client',
        pathMatch: 'full',
        redirectTo: '/',
    },
    {
        path: 'client/:clientShortcode',
        loadChildren: () => import('@app/pages/client-context/client-context.module').then(m => m.contextRoutes),
    },
    {
        path: '**',
        component: NotFoundComponent,
    },
    {
        path: '404',
        component: NotFoundComponent,
    },
]
